<!-- @format -->

<template>
    <img
        :width="width"
        :height="height"
        src="@tenant/app/assets/logo-small.png"
        alt="aadvantagehotelslogo" />
</template>

<script>
export default {
    name: 'LogoSmallIcon',
    props: {
        width: {
            type: Number,
            default: 14,
        },
        height: {
            type: Number,
            default: 14,
        },
    },
};
</script>
